import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { alertActions } from "../redux/AlertController";
import useLogout from "./useLogout";
import { generateAndDownload } from "../utils/exportApplications";

export const useApplicationExport = () => {
    const [isExporting, setIsExporting] = useState(false);
    const [progress, setProgress] = useState({ done: 0, total: 0 });

    const dispatch = useDispatch();
    const user = useSelector(state => state.userController.user);
    const navigate = useNavigate();
    const { logout } = useLogout();

    const exportApplications = async (filters, format, fileCount) => {
        if (!user) {
            navigate('/login');
            return false;
        }

        setIsExporting(true);
        setProgress({ done: 0, total: 0 });
        let success = false;

        try {
            const params = new URLSearchParams();
            Object.entries(filters).forEach(([key, value]) => {
                if (Array.isArray(value)) {
                    value.forEach((v) => params.append(key, v));
                } else if (value !== '' && value !== null && value !== undefined) {
                    params.append(key, value);
                }
            });

            const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/admin/applications/export?${params}`, {
                headers: {
                    'Authorization': `Bearer ${user?.token}`
                }
            });
            const json = await res.json();

            if (res.status === 401) {
                logout();
                setIsExporting(false);
                return false;
            }
            if (!res.ok) {
                dispatch(alertActions.showAlert({ msg: json.message, type: 'error' }));
                setIsExporting(false);
                return false;
            }
            if (json.applications.length === 0) {
                dispatch(alertActions.showAlert({ msg: 'لا توجد طلبات مطابقة للفلترة المحددة', type: 'error' }));
                setIsExporting(false);
                return false;
            }

            await generateAndDownload({
                applications: json.applications,
                format,
                fileCount,
                onProgress: (done, total) => setProgress({ done, total })
            });

            dispatch(alertActions.showAlert({ msg: 'تم إنشاء الملف بنجاح', type: 'success' }));
            success = true;
        } catch (err) {
            dispatch(alertActions.showAlert({ msg: err.message || 'تعذر إنشاء الملف', type: 'error' }));
        }

        setIsExporting(false);
        setProgress({ done: 0, total: 0 });
        return success;
    };

    return { isExporting, progress, exportApplications };
};
